"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _browser = require("@sentry/browser");
var _Context = require("../Context");
var actions = _interopRequireWildcard(require("../../actions"));
var _Menu = _interopRequireDefault(require("../Menu"));
var _Header = _interopRequireDefault(require("../Header"));
var _constants = _interopRequireWildcard(require("../../constants"));
var _AuthStrategy = require("../../services/AuthStrategy");
var _usageAnalytics = require("../../services/usageAnalytics");
var _browser2 = require("../../../components/utils/browser");
var _useBrowserTabVisibility = require("../../../hooks/useBrowserTabVisibility");
var _SessionStorage = _interopRequireDefault(require("../../../shared/SessionStorage"));
var _appconfig = require("../../selectors/appconfig");
var _menu = require("../../selectors/menu");
var _session = require("../../selectors/session");
var _ua = require("../../selectors/ua");
var _Favicon = _interopRequireDefault(require("../Favicon"));
var _Snackbar = _interopRequireDefault(require("../Notifications/Snackbar"));
var _Toastbar = _interopRequireDefault(require("../Notifications/Toastbar"));
var _Activity = require("../Activity");
var _activityTracker = _interopRequireDefault(require("../../services/activityTracker"));
var _utils = require("./utils");
var _Shimmer = _interopRequireDefault(require("./Shimmer"));
var _ErrorBoundary = _interopRequireDefault(require("./ErrorBoundary"));
var _styles = require("./styles");
var _useLibraryLoaded = require("./useLibraryLoaded");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
const getCurrentUri = () => {
  const {
    pathname,
    search,
    hash
  } = window.location;
  return `${pathname}${search}${hash}`;
};
const getAppconfigFetchingState = fetchingValue => {
  if (_AuthStrategy.authStrategy.strategy.name === _constants.AUTH_STRATEGY.NO_AUTH) {
    return false;
  }
  return fetchingValue;
};
const Layout = ({
  onLoaded,
  onLogout,
  headerActions = [],
  browserSupport = {
    unsupported: {
      ie: '<=11'
    },
    message: 'Your browser is not supported by this application after December 31, 2021. We encourage you to use Chrome/Edge'
  },
  handleNotification,
  history,
  moduleName,
  children,
  searchValueHandler
}) => {
  var _config$auth, _solutions$2, _solutions$2$children, _config$auth2, _config$auth3;
  const config = (0, _react.useContext)(_Context.ConfigContext);
  const locale = (0, _react.useContext)(_Context.LocaleContext);
  _AuthStrategy.authStrategy.set((_config$auth = config.auth) === null || _config$auth === void 0 ? void 0 : _config$auth.connector, onLoaded, onLogout, config);
  const appconfig = (0, _Context.useSelector)(_appconfig.getAppconfig);
  const appconfigFetchingValue = (0, _Context.useSelector)(_appconfig.isFetching);
  const appconfigFetching = getAppconfigFetchingState(appconfigFetchingValue);
  const solutions = (0, _Context.useSelector)(_menu.getSolutions);
  const isMenuExpanded = (0, _Context.useSelector)(_menu.isExpanded);
  const showBurgerMenu = (0, _Context.useSelector)(_menu.isBurgerMenuShown);
  const authorizedValue = (0, _Context.useSelector)(_session.isAuthorized);
  const authorized = _AuthStrategy.authStrategy.completed(authorizedValue);
  const idleModal = (0, _Context.useSelector)(_session.getIdleModal);
  const lifetimeModal = (0, _Context.useSelector)(_session.getLifetimeModal);
  const uaConnectionEstablished = (0, _Context.useSelector)(_ua.isUAConnectionEstablished);
  const activeNodePath = (0, _utils.findMenuItemPath)(solutions, getCurrentUri()) || [];
  const [, rerenderComponent] = (0, _react.useReducer)(x => x + 1, 0);
  const dispatch = (0, _Context.useDispatch)();
  (0, _useLibraryLoaded.useHeapLoad)(config.heapAppId);
  (0, _useLibraryLoaded.useDynatraceLoad)();
  const createSession = token => {
    dispatch(actions.createSessionPending(token));
  };
  const prolongSession = () => {
    dispatch(actions.prolongSession());
  };
  const initAppframe = payload => {
    dispatch(actions.initAppFrame(payload));
  };
  const runActivityTracker = () => {
    const auth = config.auth || {};
    if (auth.activityDebounce && auth.connector !== _constants.default.MID2_CONNECTOR) {
      _activityTracker.default.init(prolongSession, auth.activityDebounce);
    }
  };
  const cancelActivityTracker = () => {
    _activityTracker.default.clear();
  };
  (0, _useBrowserTabVisibility.useBrowserTabVisibility)(runActivityTracker, cancelActivityTracker);
  (0, _react.useEffect)(() => {
    if (config.heapAppId) {
      window.heap = window.heap || [], heap.load = function (e, t) {
        window.heap.appid = e, window.heap.config = t = t || {};
        var r = document.createElement("script");
        r.type = "text/javascript", r.async = !0, r.src = "https://cdn.heapanalytics.com/js/heap-" + e + ".js";
        var a = document.getElementsByTagName("script")[0];
        a.parentNode.insertBefore(r, a);
        for (var n = function (e) {
            return function () {
              heap.push([e].concat(Array.prototype.slice.call(arguments, 0)));
            };
          }, p = ["addEventProperties", "addUserProperties", "clearEventProperties", "identify", "resetIdentity", "removeEventProperty", "setEventProperties", "track", "unsetEventProperty"], o = 0; o < p.length; o++) heap[p[o]] = n(p[o]);
      };
      window.heap.load(config.heapAppId, {
        secureCookie: true,
        disableTextCapture: true,
        cookiePath: config.appPrefix
      });
    }
    (0, _utils.checkLocales)(locale, _utils.locales);
    runActivityTracker();
    _AuthStrategy.authStrategy.execAuthentication({
      createSession,
      initAppframe
    });
    const isNotificationDismissed = _SessionStorage.default.get('browser-support-notification:dismissed');
    const {
      supported
    } = (0, _browser2.getBrowserInfo)(browserSupport.unsupported);
    if (!supported && !isNotificationDismissed) {
      dispatch(actions.setToast({
        id: 'browser-support-notification',
        text: browserSupport.message,
        delay: 0,
        actions: [{
          id: 'default-hide-action',
          title: 'HIDE'
        }],
        category: 'warn'
      }, {
        callback: () => {
          _SessionStorage.default.set('browser-support-notification:dismissed', true);
        }
      }));
    }
    return () => {
      cancelActivityTracker();
    };
  }, []);
  (0, _react.useEffect)(() => {
    let unsubscribeUA = () => {};
    let unsubscribeRerender = () => {};
    if (history && moduleName) {
      if (uaConnectionEstablished) {
        _usageAnalytics.UsageAnalytics.trackEvent(moduleName, _usageAnalytics.EventTypes.NAVIGATION, 'Pageview');
      }
      unsubscribeUA = history.listen(() => {
        _usageAnalytics.UsageAnalytics.trackEvent(moduleName, _usageAnalytics.EventTypes.NAVIGATION, 'Pageview');
      });
    }
    if (history) {
      unsubscribeRerender = history.listen(() => {
        rerenderComponent();
      });
    }
    return () => {
      unsubscribeUA();
      unsubscribeRerender();
    };
  }, [moduleName, history, uaConnectionEstablished]);
  const handleError = (error, errorInfo) => {
    (0, _browser.withScope)(scope => {
      scope.setExtras(errorInfo);
      (0, _browser.captureException)(error);
    });
  };
  const isMenuHidden = (0, _react.useMemo)(() => {
    var _solutions$, _solutions$$children;
    return appconfig.hiddenMenu || solutions.length === 1 && ((_solutions$ = solutions[0]) === null || _solutions$ === void 0 ? void 0 : (_solutions$$children = _solutions$.children) === null || _solutions$$children === void 0 ? void 0 : _solutions$$children.length) === 1;
  }, [appconfig.hiddenMenu, solutions.length, solutions === null || solutions === void 0 ? void 0 : (_solutions$2 = solutions[0]) === null || _solutions$2 === void 0 ? void 0 : (_solutions$2$children = _solutions$2.children) === null || _solutions$2$children === void 0 ? void 0 : _solutions$2$children.length]);
  return _react.default.createElement(_ErrorBoundary.default, {
    onDidCatch: handleError
  }, _react.default.createElement(_Favicon.default, {
    url: appconfig.favicon,
    appPrefix: config.appPrefix,
    theme: config.theme
  }), authorized && !appconfigFetching && !config.storybookShimmer ? _react.default.createElement(_styles.Meta, null, appconfig.header && _react.default.createElement(_Toastbar.default, {
    handleNotification: handleNotification
  }), _react.default.createElement(_styles.Main, null, ((_config$auth2 = config.auth) === null || _config$auth2 === void 0 ? void 0 : _config$auth2.connector) !== _constants.default.MID2_CONNECTOR && idleModal && _react.default.createElement(_Activity.Idle, {
    localeData: locale
  }), ((_config$auth3 = config.auth) === null || _config$auth3 === void 0 ? void 0 : _config$auth3.connector) !== _constants.default.MID2_CONNECTOR && lifetimeModal && _react.default.createElement(_Activity.Lifetime, {
    localeData: locale
  }), (appconfig.menu || showBurgerMenu) && _react.default.createElement(_Menu.default, {
    activeNodePath: activeNodePath,
    hiddenMenu: isMenuHidden,
    history: history
  }), _react.default.createElement(_styles.Container, null, appconfig.header && _react.default.createElement(_Header.default, {
    showBurgerMenu: showBurgerMenu,
    activeSolution: (activeNodePath === null || activeNodePath === void 0 ? void 0 : activeNodePath[0]) || {},
    headerActions: headerActions,
    history: history,
    searchValueHandler: searchValueHandler
  }), _react.default.createElement(_Snackbar.default, {
    isHeader: appconfig.header,
    handleNotification: handleNotification
  }), _react.default.createElement(_styles.Content, {
    hiddenMenu: isMenuHidden && (appconfig.menu || showBurgerMenu),
    collapsed: !isMenuExpanded && (appconfig.menu || showBurgerMenu),
    withoutMenu: !appconfig.menu && !showBurgerMenu
  }, children)))) : _react.default.createElement(_Shimmer.default, {
    appconfig: appconfig,
    hiddenMenu: isMenuHidden && appconfig.menu,
    collapsedMenu: !isMenuExpanded && appconfig.menu
  }));
};
var _default = exports.default = Layout;